import {
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Chip,
  Typography,
} from '@material-ui/core';

import moment from 'moment';
import React from 'react';

// import bgW from 'assets/images/imagotipo.svg';
// import ellipse from 'assets/images/ellipse.svg';
// import redDots from 'assets/images/red-dots.svg';

import useStyles from './styles';

/**
 * ComingCourseFeature component
 *
 * @returns {JSX.Element}
 */

interface IProps {
  resource?: any;
}

const ResourceCard: React.FC<IProps> = ({ resource }): JSX.Element => {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardActionArea>
        <CardMedia
          component="img"
          alt={resource.title}
          height="140"
          image={resource.image.url}
          title={resource.title}
        />
        <CardContent className={classes.cardContent}>
          <Typography gutterBottom className={classes.title}>
            {resource.title}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            {`${resource.category.charAt(0).toUpperCase() + resource.category.slice(1)} by ${
              resource.author.charAt(0).toUpperCase() + resource.author.slice(1)
            }`}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            {`Published on ${moment(resource.publishedDate).format('ll')}`}
          </Typography>
          {resource.skills.map((skill: any, index: number) => (
            <Chip key={index} label={skill.name} className={classes.tags} />
          ))}
        </CardContent>
      </CardActionArea>
      <CardActions className={classes.cardActions}>
        <Button variant="contained" color="primary" href={resource.url}>
          {`Visit ${resource.category}`}
        </Button>
      </CardActions>
    </Card>
  );
};

export { ResourceCard };
